import styled, { css } from 'styled-components'

interface IWrapContainer {
  contains: number
  direction?: string
}

export const WrapContainer = styled.div<IWrapContainer>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  > * {
    width: ${({ contains }): number => Math.floor(100 / contains - 1)}%;
  }
  ${({ direction }) =>
    direction &&
    css`
      flex-direction: ${direction};
    `}
`
